// Resource Calendar Constants

export const BLOCK_TYPES = {
  WORK: 'work',
  BREAK: 'break'
};

export const BLOCK_COLORS = {
  [BLOCK_TYPES.WORK]: '#2563eb', // Blue
  [BLOCK_TYPES.BREAK]: '#dc2626' // Red
};

export const BLOCK_NAMES = {
  [BLOCK_TYPES.WORK]: 'Work',
  [BLOCK_TYPES.BREAK]: 'Break'
};

export const CALENDAR_CONFIG = {
  DEFAULT_VIEW: 'dayGridMonth',
  VIEWS: ['dayGridMonth', 'timeGridWeek', 'timeGridDay', 'listWeek', 'multiMonthYear'],
  EDITABLE: true,
  SELECTABLE: true,
  BUSINESS_HOURS: {
    daysOfWeek: [1, 2, 3, 4, 5],
    startTime: '09:00',
    endTime: '17:00'
  },
  SLOT_MIN_TIME: '06:00:00',
  SLOT_MAX_TIME: '22:00:00',
  SLOT_DURATION: '00:30:00',
  WEEKENDS: true,
  NOW_INDICATOR: true,
  WEEK_NUMBERS: true,
  NAV_LINKS: true,
  DAY_HEADER_FORMAT: { weekday: 'short' },
  EVENT_TIME_FORMAT: { hour: '2-digit', minute: '2-digit', hour12: false },
  FIRST_DAY: 1,
  RERENDER_DELAY: 10,
  WINDOW_RESIZE_DELAY: 120,
  LONG_PRESS_DELAY: 150,
  EVENT_LONG_PRESS_DELAY: 150,
  SELECT_LONG_PRESS_DELAY: 120
};
